var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "figure",
    {
      staticClass: "bg-icon-download",
      on: {
        click: function($event) {
          return _vm.handleClick(_vm.params.data)
        }
      }
    },
    [
      _c(
        "i",
        {
          staticClass: "material-icons icon-download",
          attrs: { title: "Descarcar Reporte" }
        },
        [_vm._v("\n    download\n  ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }